import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IView } from '../../../../models/request-and-responses/rest-api/interfaces/view';
import { PataviumRole } from '../../../../models/request-and-responses/rest-api/enums/role.enum.model';
import {
    ISieveConf,
    ISieveFilterObject,
    ISieveSortsObject,
    SieveOperator,
    SieveString
} from '../../../../helpers/sieve/sieveString.class';
import { DataService } from '../../../../services/data.service';
import { SieveFilter } from '../../../../helpers/sieve/sieve-filters-and-sorts';
import { View } from '../../../../models/request-and-responses/rest-api/classes/view';
import { catchError, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-superadmin-route-permissions',
    templateUrl: './route-permissions.component.html',
    styleUrls: ['./route-permissions.component.css']
})
export class SuperadminRoutePermissionsComponent implements OnInit {
    public _role: PataviumRole;
    public _roleName: string;
    public views: IView[];
    public modalRef: NgbModalRef;
    public view: IView;
    public title: string;
    public submitButtonTitle: string;
    public total: number;
    //sieve
    public page: number = null;
    public pageSize: number = null;
    public filters: ISieveFilterObject[] = [];
    public sorts: ISieveSortsObject[] = [];
    get sieveConf(): ISieveConf {
        return {
            page: this.page,
            pageSize: this.pageSize,
            filters: this.filters,
            sorts: this.sorts
        };
    }

    constructor(
        private dataService: DataService,
        private modalService: NgbModal,
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService
    ) {}

    ngOnInit() {
        const data = this.activatedRoute.snapshot.data; //see app-routing.module.ts
        this._role = data._role;
        this._roleName = data._roleName;
        this.getAllViews();
    }

    getAllViews() {
        const sieveString = new SieveString(this.sieveConf);
        sieveString.addFilters([
            {
                key: SieveFilter.View.Role,
                operator: SieveOperator.Equal,
                value: this._role
            }
        ]);
        return this.dataService
            .getViewPermissions(sieveString)
            .pipe(
                tap(response => {
                    this.views = response.payload.map(el => el);
                    this.total = response.total;
                }),
                catchError(err => {
                    console.error(err);
                    this.toastr.error(
                        `Si è verificato un errore cercando di ottenere i dati desiderati`
                    );
                    this.views = [];
                    this.total = 0;
                    return EMPTY;
                })
            )
            .subscribe(response => {}, console.error);
    }

    openModal(component, view?: View) {
        this.modalRef = this.modalService.open(component, { size: 'lg' });
        if (view) {
            this.view = view;
            this.title = 'Aggiorna view';
            this.submitButtonTitle = 'Aggiorna';
        } else {
            this.view = new View();
            this.view.roleId = this._role;
            this.title = 'Nuova view';
            this.submitButtonTitle = 'Salva';
        }
    }

    toggleView(view: IView) {
        this.dataService
            .changeViewPermission(view.id, !view.canBeVisited)
            .subscribe(null, console.error, () => this.getAllViews());
    }

    save() {
        this.dataService.updateView(this.view).subscribe(null, console.error, () => {
            this.closeModal();
            this.getAllViews();
        });
    }

    closeModal() {
        this.modalRef.close();
        this.getAllViews();
        this.view = new View();
        this.view.roleId = this._role;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/superadmin/route-permissions/route-permissions.component.ts